import { useRef, useLayoutEffect } from 'react';
const OFFSET_TOP = 40;
function useAdjustFavButtonPosition({ favButtonRef, width, fitTo, }) {
    const observerRef = useRef(null);
    useLayoutEffect(() => {
        const node = favButtonRef.current;
        if (!node || !width) {
            return;
        }
        const imageWrapper = fitTo === 'bottom' ? node.nextElementSibling : node.previousElementSibling;
        if (!imageWrapper || !(imageWrapper instanceof HTMLElement)) {
            return;
        }
        if (observerRef.current) {
            observerRef.current.disconnect();
        }
        const resizeObserver = new ResizeObserver((entries) => {
            for (const entry of entries) {
                if (entry.target === imageWrapper) {
                    const wrapperHeight = entry.contentRect.height;
                    if (wrapperHeight !== 0) {
                        node.style.top = `${wrapperHeight - OFFSET_TOP}px`;
                    }
                }
            }
        });
        resizeObserver.observe(imageWrapper);
        observerRef.current = resizeObserver;
        return () => {
            observerRef.current?.disconnect();
            observerRef.current = null;
        };
    }, [favButtonRef, width, fitTo]);
}
export default useAdjustFavButtonPosition;
